var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.29 50.758H28.831C12.933 50.758 0 63.691 0 79.588v206.056c0 15.897 12.933 28.831 28.831 28.831h22.271v76.71a12.08 12.08 0 0 0 20.619 8.541l85.251-85.25h17.104c6.671 0 12.078-5.407 12.078-12.078 0-6.672-5.409-12.079-12.078-12.079 0 0-22.69.016-22.927.04a12.03 12.03 0 0 0-7.722 3.498l-68.169 68.169s-.021-60.392-.06-60.705c-.545-6.166-5.717-11.002-12.024-11.002H28.831a4.679 4.679 0 0 1-4.674-4.674V79.588a4.679 4.679 0 0 1 4.674-4.674H372.29a4.679 4.679 0 0 1 4.674 4.674v79.055c0 6.671 5.409 12.078 12.078 12.078s12.078-5.407 12.078-12.078V79.588c0-15.897-12.933-28.83-28.83-28.83z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.169 198.492H242.754c-15.897 0-28.831 12.933-28.831 28.831v140.57c0 15.897 12.933 28.831 28.831 28.831h150.514l60.98 60.98a12.075 12.075 0 0 0 13.163 2.618 12.08 12.08 0 0 0 7.456-11.159v-52.44h8.301c15.897 0 28.831-12.933 28.831-28.831v-140.57c.001-15.897-12.932-28.83-28.83-28.83zm4.675 169.401a4.68 4.68 0 0 1-4.674 4.674h-20.376c-6.356 0-11.554 4.912-12.031 11.147-.031.264-.051 36.29-.051 36.29l-43.854-43.855c-.046-.046-.094-.089-.14-.135a9.54 9.54 0 0 0-.489-.445 12.02 12.02 0 0 0-7.951-3.003H242.754a4.679 4.679 0 0 1-4.674-4.674v-140.57a4.679 4.679 0 0 1 4.674-4.674H483.17a4.68 4.68 0 0 1 4.674 4.674v140.571z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.964 285.53c-6.667 0-12.078 5.411-12.078 12.078s5.411 12.078 12.078 12.078c6.668 0 12.078-5.411 12.078-12.078s-5.411-12.078-12.078-12.078zM310.472 130.611H90.65c-6.67 0-12.078 5.407-12.078 12.078s5.409 12.078 12.078 12.078h219.822c6.67 0 12.078-5.407 12.078-12.078s-5.408-12.078-12.078-12.078zM174.075 210.465H90.65c-6.67 0-12.078 5.407-12.078 12.078 0 6.671 5.409 12.078 12.078 12.078h83.425c6.671 0 12.078-5.407 12.078-12.078s-5.408-12.078-12.078-12.078zM306.837 285.53c-6.666 0-12.078 5.411-12.078 12.078s5.412 12.078 12.078 12.078c6.668 0 12.078-5.411 12.078-12.078s-5.41-12.078-12.078-12.078zM419.079 285.53c-6.667 0-12.078 5.411-12.078 12.078s5.411 12.078 12.078 12.078c6.668 0 12.078-5.411 12.078-12.078s-5.411-12.078-12.078-12.078z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.9e0976e153ab76ae984f228cbd301752.svg";
export { ForwardRef as ReactComponent };